import React, {useEffect, useCallback, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {Link, useHistory, useLocation} from 'react-router-dom';
import queryString from 'query-string';

import {loadBrandsAction, destroyBrandAction} from '../../../reducers/brand';

import {useFormData} from '../../../hook';
import useCheckboxForm from '../../../hook/UseCheckboxForm';

import UIKit from '../../../Components/UIKit';
import Pagination from '../Pagination';
import Loader from '../../../Components/Widget/Loader';
import HeaderDetailOptions from '../HeaderDetailOptions';

const TableStyle = () => {
  const dispatch = useDispatch();
  const {brands, loadBrandsLoading, loadBrandsDone, loadBrandError, destroyBrandDone, destroyBrand} = useSelector(state => state.brand);

  const [isShowDetailOptions, setIsShowDetailOptions] = useState(false);

  const checkboxForm = useCheckboxForm(null);
  const history = useHistory();
  const location = useLocation();

  const locationSearch = location.search;
  const parsedLocationSearch = queryString.parse(locationSearch);

  let defaultColumn = '';
  if (parsedLocationSearch.sort) {
    defaultColumn = JSON.parse(atob(parsedLocationSearch.sort));
    defaultColumn = Object.keys(defaultColumn)[0];
  }

  const sortForm = useFormData({
    column: defaultColumn ? defaultColumn : 'regdate',
    sort: 'desc',
  });

  useEffect(() => {
    let query = location.search;
    dispatch(loadBrandsAction(query));
  }, [location, destroyBrandDone]);

  useEffect(() => {
    if (loadBrandError) {
    }
  }, [loadBrandError]);

  useEffect(() => {
    if (loadBrandsDone) {
      checkboxForm.init(brands);
    }
  }, [loadBrandsDone]);

  useEffect(() => {
    if (checkboxForm && checkboxForm.value) {
      if (checkboxForm.value.total.checked) {
        setIsShowDetailOptions(true);
        return;
      }

      const keys = Object.keys(checkboxForm.value);
      for (let key of keys) {
        if (key !== 'total' && key !== 'isShowDetailOption') {
          if (checkboxForm.value[key].checked) {
            setIsShowDetailOptions(true);
            return;
          }
        }
      }
      setIsShowDetailOptions(false);
    }
  }, [checkboxForm.value]);

  const onClickDetail = useCallback(seq => {
    history.push(`/setting/brand/all/${seq}`);
  }, []);

  const onClickColumn = useCallback(
    clickedColumn => {
      let sort = {};
      let sortQuery = '';
      if (sortForm.value.column !== clickedColumn) {
        sortForm.onChange({column: clickedColumn, sort: 'desc'});
        sort[clickedColumn] = 'desc';
        sort = JSON.stringify(sort);
        sortQuery = `sort=${btoa(sort)}`;
      } else {
        sortForm.onChange({
          sort: sortForm.value.sort === 'desc' ? 'asc' : 'desc',
        });
        sort[clickedColumn] = sortForm.value.sort === 'desc' ? 'asc' : 'desc';
        sort = JSON.stringify(sort);
        sortQuery = `sort=${btoa(sort)}`;
      }

      let nextQueryString = sortQuery;
      if (location.search) {
        let nowQueryStringObj = queryString.parse(location.search);
        delete nowQueryStringObj.sort;
        if (decodeURIComponent(queryString.stringify(nowQueryStringObj))) {
          nextQueryString = `${decodeURIComponent(queryString.stringify(nowQueryStringObj))}&${sortQuery}`;
        }
      }

      history.push({
        pathname: location.pathname,
        search: nextQueryString,
      });
    },
    [history, location, sortForm],
  );

  useEffect(() => {
    if (destroyBrandDone) {
      alert(destroyBrand.data.msg);
      setIsShowDetailOptions(false);
      checkboxForm.remove(destroyBrand.brandSeq);
    }
  }, [destroyBrandDone]);

  return loadBrandsLoading ? (
    <div>
      <Loader />
    </div>
  ) : (
    loadBrandsDone && (
      <div>
        {checkboxForm && checkboxForm.value && isShowDetailOptions && <HeaderDetailOptions checkboxForm={checkboxForm} destroyModelAction={destroyBrandAction} />}

        <UIKit.Card title={''} cardOptions={'uk-card-default uk-card-style uk-margin-medium-top uk-text-0_8'} cardBodyOptions={'uk-padding-remove-top'}>
          <div>
            <span className="uk-padding-12-left uk-margin-top">
              <span className="uk-hidden@m uk-padding-xsmall-right">
                <input type="checkbox" className="uk-checkbox" />
              </span>
              <span>총 {brands.total}건</span>
            </span>
            <div className="uk-overflow-auto">
              <table className="uk-table uk-table-pointer uk-table-small uk-table-hover uk-table-divider uk-table-middle">
                <thead className="uk-text-center">
                  <tr>
                    <th className="uk-table-shrink">{checkboxForm && checkboxForm.value && <input className="uk-checkbox" type="checkbox" checked={checkboxForm.value.total.checked} onChange={checkboxForm.onChangeCheckboxAll} />}</th>
                    <th className="uk-pointer uk-table-expand">
                      <span>로고</span>
                    </th>
                    <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('name')}>
                      <span>브랜드명</span>
                      {sortForm.value.column === 'name' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                    </th>
                    <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('domain')}>
                      <span>도메인</span>
                      {sortForm.value.column === 'domain' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                    </th>
                    <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('description')}>
                      <span>설명</span>
                      {sortForm.value.column === 'description' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                    </th>
                    <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('keyword')}>
                      <span>키워드</span>
                      {sortForm.value.column === 'keyword' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                    </th>
                    <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('status')}>
                      <span>상태</span>
                      {sortForm.value.column === 'status' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                    </th>
                    <th className="uk-pointer uk-table-expand" onClick={() => onClickColumn('regdate')}>
                      <span>등록일</span>
                      {sortForm.value.column === 'regdate' && <i className={sortForm.value.sort === 'desc' ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-up'} />}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {brands &&
                    brands.data.map(brand => (
                      <tr key={brand.seq}>
                        <td>{checkboxForm && checkboxForm.value && checkboxForm.value[brand.seq] && <input className="uk-checkbox" type="checkbox" checked={checkboxForm.value[brand.seq].checked} onChange={() => checkboxForm.onChangeCheckbox(brand.seq)} />}</td>
                        <td onClick={() => onClickDetail(brand.seq)}>
                          <img className="list-img uk-preserve-width" src={brand.logo ? brand.logo : require('../../../resource/uikit/avatar.svg')} alt={'사진'} width="60" />
                        </td>
                        <td className="uk-text-center" onClick={() => onClickDetail(brand.seq)}>
                          {brand.name}
                        </td>
                        <td className="uk-text-center" onClick={() => onClickDetail(brand.seq)}>
                          {brand.domain}
                        </td>
                        <td className="uk-text-center" onClick={() => onClickDetail(brand.seq)}>
                          {brand.siteInfo.description}
                        </td>
                        <td className="uk-text-center" onClick={() => onClickDetail(brand.seq)}>
                          {brand.siteInfo.keyword}
                        </td>
                        <td className="uk-text-center" onClick={() => onClickDetail(brand.seq)}>
                          {brand.statusName}
                        </td>
                        <td className="uk-text-center" onClick={() => onClickDetail(brand.seq)}>
                          {brand.regdate}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div>
              <Pagination currentPage={brands.current_page} pageLast={brands.last_page} />
            </div>
          </div>
        </UIKit.Card>
      </div>
    )
  );
};

export default TableStyle;
